import {styled} from '@mui/material/styles'
import {
  Backdrop,
  Box,
  Button,
  TextField,
  textFieldClasses,
  Toolbar,
  Tooltip,
  tooltipClasses,
  Typography
} from '@mui/material'
import theme from '../../themes/index'

export const StyledActionBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  flexDirection: 'row',
  width: '100%',
  padding: '0 20x'
}))

export const StyledAsterisk = styled(Typography)(() => ({
  color: theme.palette.common.red,
  fontSize: theme.typography.heading.fontSize.xs
}))

export const StyledErrorMsg = styled(Typography)(() => ({
  color: theme.palette.common.red,
  fontSize: theme.typography.heading.fontSize.xxs,
  letterSpacing: '0.2px',
  fontWeight: 500,
  lineHeight: '20px',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  width: '100%'
}))

export const StyledLabel = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.heading.fontSize.xs,
  fontWeight: 500,
  letterSpacing: '0.2px',
  color: theme.palette.common.black,
  display: 'flex'
}))

export const StyledTextField = styled(TextField)(({theme}) => ({
  [`&.${textFieldClasses.root}`]: {
    borderRadius: '4px',
    width: '100%',
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.palette.common.black2,
      color: theme.palette.common.white,
      fontSize: theme.typography.heading.fontSize.xs,
      minHeight: '40px'
    }
  },
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: theme.palette.common.white,
    opacity: 0.8
  }
}))

export const StyledBackdropLoader = styled(Backdrop)(({theme}) => ({
  color: theme.palette.common.white,
  zIndex: theme.zIndex.drawer + 1
}))

export const StyledSaveButton = styled(Button)(({theme}) => ({
  backgroundColor: theme.palette.common.black2,
  color: theme.palette.common.white,
  '&:hover': {
    backgroundColor: theme.palette.common.black2,
    color: theme.palette.common.white
  },
  '&.Mui-disabled': {
    color: theme.palette.common.white,
    opacity: 0.8
  }
}))

export const StyledSuccessMsg = styled(Typography)(() => ({
  color: theme.palette.common.successGreen2,
  fontSize: theme.typography.heading.fontSize.xxs,
  letterSpacing: '0.2px',
  fontWeight: theme.typography.heading.fontWeight.semibold,
  lineHeight: '20px',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start'
}))

export const StyledToolBar = styled(Toolbar)(() => ({
  '&.MuiToolbar-root': {minHeight: '75px'}
}))

export const StyledToolTip = styled(({className, ...props}) => <Tooltip {...props} classes={{popper: className}} />)(
  ({theme}) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      width: '155px',
      marginLeft: '0 !important',
      lineHeight: '20px'
    }
  })
)
